import Button from "@components/Button";
import { useDisclosure } from "@mantine/hooks";
import Dialog from "@components/Dialog";
import { PasswordInput } from "@components/Input";
import Loading from "@components/Loading/Loading";
import {
  useChangePasswordMutation,
  useLogoutUserMutation,
  useReloadAccessMutation,
} from "@features/auth/authApiSlice";
import {
  clearState,
  enqueueSnackbar,
  makeSelectUsers,
} from "@features/auth/authSlice";
import { Menu, Drawer } from "@mantine/core";
import { APP_LOGO, APP_NAME } from "@utils/constants";
import { useState } from "react";
import { Helmet } from "react-helmet";
import {
  RiArrowDownSLine,
  RiLockLine,
  RiLogoutBoxLine,
  RiMenu2Fill,
  RiRefreshLine,
  RiUserSettingsLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import AdminSidemenuFullView from "./Components/FullView";
import "./styles.css";
import { Link } from "react-router-dom";

// const usersFromLocal = localStorage.getItem("users");
// const users = usersFromLocal ? JSON.parse(usersFromLocal) : {};

const SellerLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const users = useSelector(makeSelectUsers);

  const [openChangePW, setOpenChangePW] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);

  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
  });
  const [pwError, setPWError] = useState({});

  // rtk part;
  const [logoutUser] = useLogoutUserMutation();
  // reload user module access
  const [reloadAccess, { isLoading: reloadLoading, isError: reloadError }] =
    useReloadAccessMutation();
  // change password;
  const [changePassword, { isLoading: changePWloading }] =
    useChangePasswordMutation();

  const handleLogout = () => {
    logoutUser();
    localStorage.clear();
    sessionStorage.clear();
    dispatch(clearState());
    navigate("/login");
  };

  const hanndleToggleOpenChangePW = () => {
    setOpenChangePW((prev) => !prev);
    if (openChangePW) {
      setPWError({});
      setPassword({
        newPassword: "",
        oldPassword: "",
      });
    }
  };

  const handleChangeNewPW = (key) => (e) => {
    setPassword((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  const handleChangePassowrd = () => {
    if (
      password?.oldPassword !== "" &&
      password?.newPassword !== "" &&
      password.oldPassword === password.newPassword
    ) {
      setPWError((prev) => ({
        ...prev,
        newPassword: "You cannot use old password. Use new one.",
      }));
    } else {
      changePassword(password)
        .unwrap()
        .then((res) => {
          if (res?.success) {
            dispatch(
              enqueueSnackbar({
                message: "Password updated successfully.",
                options: {
                  variant: "success",
                },
              })
            );
            handleLogout();
          }
        })
        .catch((err) => {
          setPWError(err?.data?.errors);
        });
    }
  };

  return (
    <>
      <Helmet>
        <title>Your Dashboard</title>
      </Helmet>
      {reloadLoading ? <Loading /> : null}
      <>
        <main className='relative bg-[#f5f7fa] text-xs'>
          <div className='flex h-screen'>
            <div
              className='bg-white hidden lg:block'
              style={{
                boxShadow:
                  "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
              }}
            >
              <div className='flex my-4'>
                <Link to='/' target='_blank' className='mx-auto'>
                  <img className='w-48' src={APP_LOGO} alt={APP_NAME} />
                </Link>
              </div>
              <div
                className='overflow-y-auto w-[250px]'
                style={{
                  height: "calc(100vh - 66px)",
                }}
                id='colored_scrollbars'
              >
                <div className='dash_sidemenu select-none pb-8 relative mx-2'>
                  <AdminSidemenuFullView />
                </div>
              </div>
            </div>
            <div className='lg:hidden'>
              <Drawer opened={opened} onClose={close} title='Menu' size='xs'>
                <AdminSidemenuFullView close={close} />
              </Drawer>
            </div>
            <div className='flex-1'>
              <div className='bg-white p-3 mb-2 mt-3 mx-4 rounded-lg shadow flex justify-between items-center'>
                <div className='flex-1 flex items-center  gap-4 lg:invisible'>
                  <span onClick={open}>
                    <RiMenu2Fill className='text-2xl' />
                  </span>
                  <Link to='/'>
                    <img className='h-3' src={APP_LOGO} alt={APP_NAME} />
                  </Link>
                </div>
                <div className='flex items-center gap-2'>
                  <Menu
                    shadow='md'
                    width={200}
                    withArrow
                    offset={1}
                    position='top-end'
                  >
                    <Menu.Target>
                      <button className='bg-gray-100 py-2 px-3 flex items-center gap-2 hover:bg-gray-200 rounded-lg group'>
                        <RiUserSettingsLine size={19} />
                        <div className='inline-block text-sm w-24 truncate'>
                          {users.name}
                        </div>
                        <RiArrowDownSLine
                          size={19}
                          className='group-hover:rotate-180 duration-200'
                        />
                      </button>
                    </Menu.Target>
                    <Menu.Dropdown>
                      <Menu.Item>
                        <div
                          className='flex items-center gap-2'
                          title='Refresh Access'
                          onClick={reloadAccess}
                        >
                          <RiRefreshLine size={19} />
                          Reload Access
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div
                          className='flex items-center gap-2'
                          title='Change Password'
                          onClick={hanndleToggleOpenChangePW}
                        >
                          <RiLockLine size={19} />
                          Change Password
                        </div>
                      </Menu.Item>
                      <Menu.Item
                        style={{
                          margin: "4px 0",
                        }}
                        onClick={handleLogout}
                      >
                        <div className='flex items-center gap-2'>
                          <RiLogoutBoxLine size={19} />
                          Logout
                        </div>
                      </Menu.Item>
                    </Menu.Dropdown>
                  </Menu>
                </div>
              </div>
              <div
                className='h-full overflow-auto pb-4 px-4 pt-3'
                style={{ maxHeight: "calc(100vh - 80px)" }}
                id='main_content_container'
              >
                <Outlet />
              </div>
            </div>
          </div>
        </main>
        <Dialog
          opened={openChangePW}
          title='Change Your Password'
          onClose={hanndleToggleOpenChangePW}
          size='md'
        >
          <PasswordInput
            label='Old Password'
            value={password.oldPassword || ""}
            onChange={handleChangeNewPW("oldPassword")}
            id='old_password'
            className='w-full mb-4'
            error={pwError?.oldPassword}
          />
          <PasswordInput
            label='New Password'
            value={password.newPassword || ""}
            onChange={handleChangeNewPW("newPassword")}
            id='new_password'
            className='w-full mb-4'
            description='After changing password you will be logged out.'
            error={pwError?.newPassword}
          />
          <Button onClick={handleChangePassowrd} loading={changePWloading}>
            Reset Password
          </Button>
        </Dialog>
      </>
    </>
  );
};

export default SellerLayout;
